// Featured Products Scroll Animation
// Updates the fixed information block as you scroll through product rows

;(function () {
  gsap.registerPlugin(ScrollTrigger)

  const contexts = new WeakMap()

  function initFeaturedProductsScroll(scope = document) {
    if (contexts.has(scope)) {
      contexts.get(scope).revert()
    }

    const ctx = gsap.context(() => {
      const sections = scope.querySelectorAll('.product-row')

      if (sections.length === 0) return

      // Get the section ID from the first product row
      const sectionId = sections[0].dataset.sectionId
      if (!sectionId) return

      // Get all the text elements in the fixed info block
      // Note: These might be outside the 'scope' if the scope is just a product-row,
      // but usually 'scope' is document or the parent section.
      // If scope is the section container, these IDs should be inside it.
      const titleEl = scope.querySelector(`#product-title-${sectionId}`)
      const priceEl = scope.querySelector(`#product-price-${sectionId}`)
      const subtitleEl = scope.querySelector(`#product-subtitle-${sectionId}`)
      const sourcingEl = scope.querySelector(`#sourcing-tag-${sectionId}`)
      const fixedInfo = scope.querySelector(`#fixed-product-info-${sectionId}`)

      if (!titleEl || !priceEl || !subtitleEl || !sourcingEl || !fixedInfo)
        return

      let currentIndex = 0
      let isInitialized = false

      // Function to animate text change
      const animateTextChange = (element, newText) => {
        const timeline = gsap.timeline()

        timeline
          .to(element, {
            yPercent: -20,
            opacity: 0,
            duration: 0.3,
            ease: 'power2.in',
          })
          .call(() => {
            element.textContent = newText
          })
          .to(element, {
            yPercent: 0,
            opacity: 1,
            duration: 0.4,
            ease: 'power2.out',
            clearProps: 'opacity',
          })

        return timeline
      }

      // Function to update all content
      const updateContent = (index, shouldAnimate = true) => {
        // Skip if we're already on this index
        if (index === currentIndex && isInitialized) return
        currentIndex = index

        const productRow = sections[index]
        const title = productRow.dataset.productTitle
        const price = productRow.dataset.productPrice
        const subtitle = productRow.dataset.productSubtitle
        const sourcing = productRow.dataset.productSourcing
        const url = productRow.dataset.productUrl

        // Update the link href
        if (url) {
          fixedInfo.href = url
        }

        // If this is the initial setup, just set the text without animation
        if (!shouldAnimate) {
          titleEl.textContent = title
          priceEl.textContent = price
          subtitleEl.textContent = subtitle
          sourcingEl.textContent = sourcing
          isInitialized = true
          return
        }

        // Animate all text changes in parallel
        const masterTimeline = gsap.timeline()

        masterTimeline
          .add(animateTextChange(titleEl, title), 0)
          .add(animateTextChange(priceEl, price), 0.05)
          .add(animateTextChange(subtitleEl, subtitle), 0.1)
          .add(animateTextChange(sourcingEl, sourcing), 0)

        isInitialized = true
      }

      // Create scroll triggers for each product row
      sections.forEach((section, index) => {
        ScrollTrigger.create({
          trigger: section,
          start: 'top center',
          end: 'bottom center',
          onEnter: () => updateContent(index),
          onEnterBack: () => updateContent(index),
        })
      })

      // Initialize with first product (no animation)
      updateContent(0, false)
    }, scope)

    contexts.set(scope, ctx)
  }

  function cleanup(scope) {
    if (contexts.has(scope)) {
      contexts.get(scope).revert()
      contexts.delete(scope)
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    initFeaturedProductsScroll(document)
  })

  document.addEventListener('shopify:section:load', (e) => {
    initFeaturedProductsScroll(e.target)
  })

  document.addEventListener('shopify:section:unload', (e) => {
    cleanup(e.target)
  })
})()
